<template>
  <CSidebar position="fixed" :unfoldable="sidebarUnfoldable" :visible="sidebarVisible" @visible-change="
    (event) =>
      $store.commit({
        type: 'updateSidebarVisible',
        value: event,
      })
  ">
    <router-link to="/dashboard">
      <CSidebarBrand class="sidebar-brand-wrapper">
        <img
          v-if="logoSrc"
          class="sidebar-brand-logo"
          :class="{ 'logo-hidden': !isLogoLoaded }"
          :src="logoSrc"
          alt="logo"
          @load="handleLogoLoad"
        >
      </CSidebarBrand>

    </router-link>

    <AppSidebarNav />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import AppSidebarNav from '@/components/base/AppSidebarNav.vue'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav
  },
  emits: ['toggleModal'],
  setup() {
    const store = useStore()
    return {
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible)
    }
  },

  data() {
    return {
      logoSrc: null,
      isLogoLoaded: false,
      fallbackLogo: '/brand/logo/ufo.svg',
    }
  },

  mounted() {
    this.getLogoSetting()
  },
  methods: {
    toggleModal() {
      this.$emit('toggleModal', true)
    },

    getLogoSetting() {
      this.$store.dispatch('finances/getSettingByKey', { key: 'company_logo' }).then(res => {
        const logo = res?.data?.data?.value || this.fallbackLogo
        this.logoSrc = logo
      }).catch(() => {
        this.logoSrc = this.fallbackLogo
      })
    },

    handleLogoLoad() {
      this.isLogoLoaded = true
    }
  },
}
</script>

<style lang="scss" scoped>
.sidebar-brand {
  &-wrapper {
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  &-logo {
    max-height: 55px;
    margin: 8px 20px;
    width: auto;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  .logo-hidden {
    opacity: 0;
  }
}
</style>
<!-- nav color -->
<style lang="scss">
@use 'sass:color';
.sidebar {
  background-color: $primary-main !important;
  opacity: 1 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  filter: none !important;

  min-height: 100vh;
}

.sidebar-nav {
  min-height: 100vh;
}

.nav-group {
  background: none !important;
}

.router-link-active {
  font-weight: 700;

}


.sidebar-nav a {
  color: white !important;
}

.nav-link svg {
  color: white !important;
}

.sidebar,
.sidebar>* {
  background-color: $primary-main !important;
}

.nav-group-items {
  background-color: color.adjust($primary-main, $lightness: 5%) !important;
}
</style>